module.exports = __webpack_public_path__ + "static/media/5.f2b4d8bd.jpg";